/**
 * Removes specified properties from an object and returns a new object without them
 * @param obj The source object
 * @param keysToOmit Array of keys to remove from the object
 * @returns A new object without the specified properties
 */
export function omit<T extends Record<string, any>, K extends keyof T>(
  obj: T,
  keysToOmit: K[]
): Omit<T, K> {
  const result = { ...obj };

  keysToOmit.forEach((key) => {
    delete result[key];
  });

  return result;
}

/**
 * Removes a single property from an object and returns a new object without it
 * @param obj The source object
 * @param keyToOmit Key to remove from the object
 * @returns A new object without the specified property
 */
export function omitProperty<T extends Record<string, any>, K extends keyof T>(
  obj: T,
  keyToOmit: K
): Omit<T, K> {
  const { [keyToOmit]: _, ...rest } = obj;
  return rest as Omit<T, K>;
}
